const getModeConfig = (config, key) => config?.refund_config?.modes?.[key] || {};

export const getStoreCreditSource = (config) => {
  const storeCreditProviders = getModeConfig(config, "store_credit")?.providers || {};

  if (storeCreditProviders.credits_yard?.configured) {
    return "credits_yard";
  }

  if (storeCreditProviders.easyrewardz?.configured) {
    return "easyrewardz";
  }

  return null;
};

export const getSingleRefundModeSource = (config, mode) => {
  switch (mode) {
    case "coupon_code":
      return "coupon";
    case "gift_card":
      return "gift_card";
    case "source_refund":
    case "refund_to_source":
      return "refund_to_source";
    case "shopify_store_credit":
      return "shopify_store_credit";
    case "store_credit":
      return getStoreCreditSource(config);
    default:
      return null;
  }
};

export const normalizeRmsConfig = (config = {}) => {
  const refundModes = config?.refund_config?.modes;
  if (!refundModes) {
    return config;
  }

  const bankTransfer = refundModes.bank_transfer || {};
  const upi = refundModes.upi || {};
  const couponCode = refundModes.coupon_code || {};
  const giftCard = refundModes.gift_card || {};
  const storeCredit = refundModes.store_credit || {};
  const refundToSource = refundModes.refund_to_source || {};
  const storeCreditProviders = storeCredit.providers || {};

  const bankTransferDirectTransferAvailable =
    !!bankTransfer.enabled && !!bankTransfer.available_via_direct_transfer;
  const upiDirectTransferAvailable =
    !!upi.enabled && !!upi.available_via_direct_transfer;
  const storeCreditAvailable = !!storeCredit.available;

  return {
    ...config,
    show_only_gc_for_cod_orders: false,
    show_only_gc_and_source_refund_for_prepaid_orders: false,
    customer_bank_enabled: bankTransferDirectTransferAvailable,
    customer_upi_enabled: upiDirectTransferAvailable,
    collect_bank_details_for_cod_orders:
      bankTransferDirectTransferAvailable && !!bankTransfer.visible_on?.cod,
    collect_upi_details_for_cod_orders:
      upiDirectTransferAvailable && !!upi.visible_on?.cod,
    coupon_refund_enabled: !!couponCode.available,
    gift_card: !!giftCard.available,
    store_credit: storeCreditAvailable,
    credits_yard:
      storeCreditAvailable && !!storeCreditProviders.credits_yard?.configured,
    easyrewardz:
      storeCreditAvailable && !!storeCreditProviders.easyrewardz?.configured,
    shopify_store_credit:
      storeCreditAvailable && !!storeCreditProviders.shopify?.configured,
    refund_to_source: !!refundToSource.available,
  };
};
